import { gql } from "@apollo/client";

export const SET_GROUP_ADMIN = gql`
  mutation setGroupAdmin($input: SetSkynetUserGroupAdminInput!) {
    rolesAndPermissions {
      setGroupAdmin(input: $input) {
        success
      }
    }
  }
`;
